/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Decks_Expand_AllInputs */



/**
* | output |
* | --- |
* | "Expand all" |
*
* @param {Decks_Expand_AllInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_expand_all = /** @type {((inputs?: Decks_Expand_AllInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_Expand_AllInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tout développer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Expandir todo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Expandir tudo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Espandi tutto")
	return /** @type {LocalizedString} */ ("Expand all")
});